<template>
    <div
        v-if="showing"
        class="fixed inset-0 w-full h-screen flex items-center justify-center bg-smoke-200 z-50"
        @mousedown="trackMouseDown"
        @mouseup="checkClose"
        :class="customCSS.background"
    >

                <div class="modal flex flex-col w-11/12 sm:w-5/6 lg:w-1/2 max-w-2xl max-h-full mx-auto rounded-lg border-gray-300 shadow-xl">
                    <div
                        class="relative flex flex-row justify-between p-6 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
                        :class="customCSS.modal"
                    >
                        <p class="font-semibold text-gray-800" v-if="hasHeaderSlot">
                            <slot name="header"></slot>
                        </p>
                        <button
                            v-if="showClose"
                            aria-label="close"
                            :class="customCSS.close"
                            @click.prevent="close"
                        >
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="flex flex-col px-6 py-5 bg-white overflow-y-auto">
                        <slot></slot>
                    </div>
                    <div
                        class="flex flex-row items-center justify-between p-5 bg-white border-t border-gray-200 rounded-bl-lg rounded-br-lg"
                        v-if="hasFooterSlot"
                    >
                        <slot name="footer"></slot>
                    </div>
                </div>
        </div>
</template>

<script>
export default {
    props: {
        showing: {
            required: true,
            type: Boolean
        },
        showClose: {
            type: Boolean,
            default: true
        },
        backgroundClose: {
            type: Boolean,
            default: true,
        },
        css: {
            type: Object,
            required: false
        }
    },
    computed: {
        customCSS() {
            return {...{
                    background: '',
                    modal: '',
                    close: ''
                }, ...this.css}
        },
        hasHeaderSlot() {
            return !!this.$slots.header
        },
        hasFooterSlot() {
            return !!this.$slots.footer
        }
    },
    watch: {
        showing(value) {
            if (value) {
                return document.querySelector("body").classList.add("overflow-hidden");
            }
            return document.querySelector("body").classList.remove("overflow-hidden");
        }
    },
    methods: {
        close() {
            document.querySelector("body").classList.remove("overflow-hidden");
            this.$emit("close");
        },
        trackMouseDown(event) {
            // Проверяем, началось ли взаимодействие внутри модалки
            this.mouseDownInsideModal = this.isInsideModal(event.target);
        },
        checkClose(event) {
            if (this.showClose && this.backgroundClose) {
                // Закрываем модалку только если взаимодействие началось вне модалки
                const mouseUpInsideModal = this.isInsideModal(event.target);
                if (!this.mouseDownInsideModal && !mouseUpInsideModal) {
                    this.close();
                }
            }
        },
        isInsideModal(target) {
            return target.closest && target.closest('.modal') !== null;
        }
    },
    mounted: function() {
        if (this.showClose) {
            document.addEventListener("keydown", e => {
                if (e.key === "Escape") {
                    this.close();
                }
            });
        }
    }
};
</script>

<style>
.bg-smoke-200{
    background: rgba(0, 0, 0, 0.25);
}
</style>
